import React, { useEffect, useState } from "react";
import "styles/components/menu/company/HistoryTab.scss";
import history from 'assets/data/history.json';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

// 슬라이드 하단 이전 화살표
const PrevArrow = (props) => {

    const { style, onClick, moreThan768, clickArrow, setClickArrow } = props;

    const pcStyle = {
        ...style, position: 'absolute', top: '-9.5rem', left: '50rem', color: 'rgb(0, 0, 180)', zIndex: 2, fontSize: '3rem'
    }

    const mobileStyle = {
        position: 'absolute', fontSize: '3rem', top: '0', zIndex: 5, right: '8rem', color: 'rgb(0, 0, 180)'
    }

    const handleClick = () => {
        setClickArrow(!clickArrow);
        const prevArrow = document.querySelector('.prev');
        if (prevArrow.style.color !== 'rgba(0, 0, 180, 0.3)') {
            onClick();
        }
    }

    return (
        <div
            className='slick-arrow history prev'
            style={moreThan768 ? pcStyle : mobileStyle}
            onClick={handleClick}
        >
            <FontAwesomeIcon icon={faArrowLeft} size={moreThan768 ? '2x' : '1x'} />
        </div >
    );
}

// 슬라이드 하단 다음 화살표
const NextArrow = (props) => {
    const { style, onClick, moreThan768, clickArrow, setClickArrow } = props;

    const pcStyle = {
        ...style, position: 'absolute', top: '-9.5rem', left: '60rem', color: 'rgb(0, 0, 180)', zIndex: 2, fontSize: '3rem'
    }

    const mobileStyle = {
        position: 'absolute', fontSize: '3rem', top: '0', zIndex: 5, right: '3rem', color: 'rgb(0, 0, 180)'
    }

    const handleClick = () => {
        setClickArrow(!clickArrow);
        const nextArrow = document.querySelector('.next');
        if (nextArrow.style.color !== 'rgba(0, 0, 180, 0.3)') {
            onClick();
        }
    }

    return (
        <div
            className='slick-arrow history next'
            style={moreThan768 ? pcStyle : mobileStyle}
            onClick={handleClick}
        >
            <FontAwesomeIcon icon={faArrowRight} size={moreThan768 ? '2x' : '1x'} />
        </div>
    );
}

const HistoryTab = () => {

    const [moreThan768, setMoreThan768] = useState(window.innerWidth >= 768 ? true : false);
    const [clickArrow, setClickArrow] = useState(false);

    const handleMoreThan768 = () => {
        const winSize = window.innerWidth;

        if (winSize >= 768) {
            setMoreThan768(true);
        } else {
            setMoreThan768(false);
        }
    }

    const [activeIdx, setActiveIdx] = useState(0);

    const handleAfterChange = (index) => {
        setActiveIdx(index);
    }

    useEffect(() => {
        window.addEventListener('resize', handleMoreThan768);
        return () => {
            window.removeEventListener('resize', handleMoreThan768);
        }
    }, []);



    useEffect(() => {
        const firstIdx = parseInt(document.querySelector('.slick-track').firstChild.dataset.index);
        let lastIdx = parseInt(document.querySelector('.slick-track').lastChild.dataset.index);
        const prevArrow = document.querySelector('.prev');
        const nextArrow = document.querySelector('.next');

        if (window.innerWidth < 1024) {
            lastIdx = lastIdx - 1;
        } else {
            lastIdx = lastIdx - 2;
        }

        if (activeIdx !== firstIdx) {
            prevArrow.style.color = 'rgb(0, 0, 180)';
            prevArrow.style.cursor = 'pointer';
        } else if (activeIdx === firstIdx) {
            prevArrow.style.color = 'rgba(0, 0, 180, 0.3)';
            prevArrow.style.cursor = 'default';
        }

        if (activeIdx !== lastIdx) {
            nextArrow.style.color = 'rgb(0, 0, 180)';
            nextArrow.style.cursor = 'pointer';
        } else if (activeIdx === lastIdx) {
            nextArrow.style.color = 'rgba(0, 0, 180, 0.3)';
            nextArrow.style.cursor = 'default';
        }
    }, [activeIdx]);

    // 슬라이드 설정
    const settings = {
        dots: false, // 개수 표시 점
        infinite: false, // 무한 캐러셀
        speed: 500, // 다음 컨텐츠 까지의 속도
        slidesToShow: 1, // 화면에 보이는 컨텐츠 수
        slidesToScroll: 1, // 스크롤 시 넘어가는 컨텐츠 수
        centerMode: false, // 현재 컨텐츠 가운데 정렬
        centerPadding: '10px', // 중앙 컨텐츠 padding 값
        autoplay: false, // 자동 캐러셀
        autoplaySpeed: 5000, // 자동 캐러셀 속도
        draggable: true, // 드래그      
        fade: false, // 사라졌다 나타나는 효과
        arrows: true, // 좌,우 버튼
        prevArrow: <PrevArrow moreThan768={moreThan768} clickArrow={clickArrow} setClickArrow={setClickArrow} />,
        nextArrow: <NextArrow moreThan768={moreThan768} clickArrow={clickArrow} setClickArrow={setClickArrow} />,
        vertical: false, // 세로 캐러셀
        initialSlide: 0, // 첫 컨텐츠 번호
        pauseOnFocus: true, // focus시 정지
        pauseOnHover: true, // hover시 정지
        afterChange: handleAfterChange,
        responsive: [
            {
                breakpoint: 374, // breakpoint 는 max-width 의미
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 549,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 3000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    };

    return (
        <section className="HistoryTab">
            <div className="history-wrapper">
                <div className="title">
                    <p>어질인소프트가 <br className="lineBreak" />성실하게 걸어온 <br className="lineBreak" />발자취입니다</p>
                </div>
            </div>
            <div className="slide-wrapper">
                <Slider {...settings}>
                    {history.map((el, idx) => (
                        <div className={`slide slide${idx}`} key={el.yearly}>
                            <div className="year-content">
                                <div className="year">{el.yearly}</div>
                                {el.monthly.map((monthcontent) => (
                                    <div className="month-content" key={monthcontent.month}>
                                        <div className="month">{monthcontent.month}</div>
                                        <div className="content">
                                            {monthcontent.content.map((content, idx) => (<p className="content-line" key={idx}>{content}</p>))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default HistoryTab; 